import React, { useEffect, useState } from 'react';
import { Menu, styled, TextField, Typography, useTheme, Box, Button, FormControl,Select, MenuItem } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const RowBox = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '10px',
    width: '100%'
}))

const RowInnerBox = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'space-between',
    width: 'calc(100%/2 - 5px)',
    gap: '5px'
}))

const Key = styled(Typography)(({ theme }) => ({
    fontWeight: 500,
    color: theme.palette.grey[600],
}))

const ITEM_HEIGHT = 38;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 'auto',
        },
    },
};

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

const FilterMenu = ({ anchorEl, open, handleClose, reset, apply, isFilterApplied }) => {
    const [from, setFrom] = useState(null);
    const [to, setTo] = useState(null);
    const [cli, setCli] = useState('');
    const [assignedUserId, setAssignedUserId] = useState('')
    const [status, setStatus] = useState('');
    const [deletedCli, setDeletedCli] = useState('');
    const [dateErrors, setDateErrors] = useState({ from: '', to: '' });

    useEffect(() => {
        if (!isFilterApplied) {

            setFrom(null);
            setTo(null);
            setCli('');
            setAssignedUserId('');
            setStatus('');
            setDeletedCli('');
            setDateErrors({ from: '', to: '' });
        }

    }, [isFilterApplied])

    const resetFilter = () => {

        setFrom(null);
        setTo(null);
        setCli('');
        setAssignedUserId('');
        setStatus('');
        setDeletedCli('');
        setDateErrors({ from: '', to: '' });
        reset()
    }

    const applyFilter = () => {
        const errors = { from: '', to: '' };
        const hasFrom = from !== null;
        const hasTo = to !== null;
        const isFromValid = !hasFrom || (dayjs.isDayjs(from) && from.isValid());
        const isToValid = !hasTo || (dayjs.isDayjs(to) && to.isValid());

        if (hasFrom && !isFromValid) errors.from = 'Enter a valid From date.';
        if (hasTo && !isToValid) errors.to = 'Enter a valid To date.';

        if (isFromValid && isToValid) {
            if (hasFrom && !hasTo) errors.to = 'To date is required when From date is selected.';
            if (!hasFrom && hasTo) errors.from = 'From date is required when To date is selected.';

            if (hasFrom && hasTo && from.startOf('day').isAfter(to.startOf('day'))) {
                errors.from = 'From date cannot be later than To date.';
                errors.to = 'To date cannot be earlier than From date.';
            }
        }

        setDateErrors(errors);
        if (errors.from || errors.to) return;

        const data = {
            cli,
            assignedUserId,
            deletedCli,
            status,
        }

        if (from && to) {
            data.from = from.startOf('day').valueOf();
            data.to = to.endOf('day').valueOf();
        }

        apply(data)
    }

    return (
        <Menu
            id="filter-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
                'aria-labelledby': 'filter-button',
            }}
        >
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: '20px',
                gap: '15px'
            }}>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <RowBox>
                        <RowInnerBox>
                            <Key>
                                From
                            </Key>

                            <DatePicker
                                slotProps={{
                                    textField: {
                                        size: 'small',
                                        error: Boolean(dateErrors.from),
                                        helperText: dateErrors.from,
                                    },
                                }}
                                value={from}
                                maxDate={to || undefined}
                                onChange={(value) => {
                                    setFrom(value);
                                    setDateErrors({ from: '', to: '' });
                                }}
                            />
                            {/* <TextField
                                size='small'
                                placeholder='Enter Product Id'
                                value={productId}
                                onChange={(e) => setProductId(e.target.value)}
                            /> */}
                        </RowInnerBox>

                        <RowInnerBox>
                            <Key>
                                To
                            </Key>

                            <DatePicker
                                slotProps={{
                                    textField: {
                                        size: 'small',
                                        error: Boolean(dateErrors.to),
                                        helperText: dateErrors.to,
                                    },
                                }}
                                value={to}
                                minDate={from || undefined}
                                onChange={(value) => {
                                    setTo(value);
                                    setDateErrors({ from: '', to: '' });
                                }} />
                            {/* <TextField
                                size='small'
                                placeholder='Enter Plan Id'
                                value={planId}
                                onChange={(e) => setPlanId(e.target.value)}
                            /> */}
                        </RowInnerBox>

                    </RowBox>
                </LocalizationProvider>

                <RowBox>
                    <RowInnerBox>
                        <Key>
                            CLI
                        </Key>

                        <TextField
                            size='small'
                            placeholder='Enter CLI'
                            value={cli}
                            onChange={(e) => setCli(e.target.value)}
                        />
                    </RowInnerBox>

                    <RowInnerBox>
                        <Key>
                            Assigned User Id
                        </Key>

                        <TextField
                            size='small'
                            placeholder="Enter Assigned User Id"
                            value={assignedUserId}
                            onChange={(e) => setAssignedUserId(e.target.value)}
                        />
                    </RowInnerBox>

                </RowBox>

                <RowBox>
                    <RowInnerBox>
                        <Key>
                            Status
                        </Key>

                        <FormControl>
                            <Select
                            id="demo-multiple-chip"
                            size='small'
                            value={status}
                            displayEmpty
                            onChange={(e) => setStatus(e.target.value)}
                            >
                            <MenuItem value="" disabled>
                                <em>Select Status</em>
                            </MenuItem>
                            <MenuItem value="1">Active</MenuItem>
                            <MenuItem value="0">Inactive</MenuItem>
                            </Select>
                        </FormControl>
                    </RowInnerBox>
                    <RowInnerBox>
                        <Key>
                            Deleted CLI
                        </Key>
                        <Select
                            id="demo-multiple-chip"
                            size='small'
                            value={deletedCli}
                            displayEmpty
                            onChange={(e) => setDeletedCli(e.target.value)}
                            >
                            <MenuItem value="" disabled>
                                <em>Select Deleted CLI</em>
                            </MenuItem>
                            <MenuItem value="1">Yes</MenuItem>
                            <MenuItem value="0">No</MenuItem>
                            </Select>
                    </RowInnerBox>


                </RowBox>

                <Box sx={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'flex-end',
                    gap: '8px',
                    mt: '10px'
                }}>

                    <Button
                        variant='contained'
                        sx={{ boxShadow: "none" }}
                        onClick={() => applyFilter()}
                    >
                        Apply
                    </Button>

                    <Button
                        variant='outlined'
                        color='warning'
                        sx={{ boxShadow: "none" }}
                        onClick={() => resetFilter()}
                    >
                        Reset Filters
                    </Button>

                    <Button
                        variant='outlined'
                        sx={{ boxShadow: "none" }}
                        onClick={() => handleClose()}
                    >
                        Close
                    </Button>

                </Box>

            </Box>
        </Menu>
    )
}

export default FilterMenu
